export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12006.fe8bd9c6.jpg";